module.exports = __webpack_public_path__ + "img/Frente-30-02 open.b881fb5f.jpg";